// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "feature-app." + chunkId + "." + {"162":"5ad3dd4ce8a267396060","636":"335f9e186bd5938876c1"}[chunkId] + ".js";
};